import { render, staticRenderFns } from "./HoverLink.vue?vue&type=template&id=685e7a26&scoped=true&"
import script from "./HoverLink.vue?vue&type=script&lang=js&"
export * from "./HoverLink.vue?vue&type=script&lang=js&"
import style0 from "./HoverLink.vue?vue&type=style&index=0&id=685e7a26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e7a26",
  null
  
)

export default component.exports